
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publish-on-trialsite",
      function () {
        return require("private-next-pages/publish-on-trialsite/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publish-on-trialsite"])
      });
    }
  